import { OnInit, Directive, ElementRef, Input, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { StorageService } from 'src/app/services/storage/storage.service';
import { InfoFuncionalidade } from '../../../services/auth/auth.service';

@Directive({
  selector: '[customTooltip]',
  providers: [MatTooltip]
})
export class CustomTooltipDirective implements OnInit {
  funcionalidades = JSON.parse(StorageService.getPerfilUsuario().funcionalidade_ajuda);
  mensagem: string;

  @Input('customTooltip') data: string;
  
  constructor(
    private el: ElementRef,
    public tooltip: MatTooltip
  ) {
    this.tooltip = tooltip;
  }

  ngOnInit() {
    let [campo, funcionalidade] = this.data.split('#');

    this.mensagem = this.funcionalidades
      .find((item: InfoFuncionalidade) => 
        (item.funcionalidadeNome === funcionalidade) && item.campo === (!campo ? null : campo))
      ?.descricao;
  }

  @HostListener('mouseenter') mouseenter() {
    this.tooltip.message = this.mensagem;
    this.tooltip.show();
  }

  @HostListener('mouseleave') mouseleave() {
    this.tooltip.hide();
  }
}
